import React, { useState, useEffect } from "react";
import { Button, Card, Col, Container, Row } from "reactstrap";
import MainNavigation from "../components/MainNavigation";
import { Tabs, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import completed from "../assets/img/completed.svg";
import incomplete from "../assets/img/incomplete.svg";
import cancel from "../assets/img/cancel.svg";
import { useHistory } from "react-router-dom";
import { getOrderHistoryAction } from "../store/actions/orderAction";
import moment from "moment";
import TipModal from "../components/Modals/TipModal";
import RestaurantLoader from "../utils/RestaurantLoader";

const OrderHistory = () => {
  const { darkMode, color } = useSelector((state) => state.global);
  const { uid } = useSelector((state) => state.authUser);
  const [modal, setModal] = useState(false);
  const [tipAdded, setTipAdded] = useState(false);
  const [OrderId, setOrderId] = useState("");
  const [restaurantId, setRestaurantId] = useState("");
  const [price, setPrice] = useState(0);
  const [activeTab, setActiveTab] = useState("active");
  const [visibleItems, setVisibleItems] = useState(10);
  const [currency, setCurrency] = useState("");
  const [loadingMore, setLoadingMore] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { orderHistory, getOrders } = useSelector((state) => state.orders);

  const handleModal = (item) => {
    setRestaurantId(item?.restaurantID);
    setPrice(item?.finalPrice);
    setCurrency(item?.currency);
    setOrderId(item?.id);
    setModal(true);
  };

  const filterOrders = (status) => {
    return orderHistory?.filter((item) => {
      if (status === "active") {
        return (
          item.status !== "completed" &&
          item.status !== "refunded" &&
          item.status !== "closed"
        );
      } else if (status === "completed") {
        return item.status === "completed";
      } else if (status === "refunded") {
        return item.status === "refunded";
      } else if (status === "closed") {
        return item.status === "closed";
      }
      return true;
    });
  };

  const totalquantity = (order) => {
    const totalQuantity = order?.reduce((acc, item) => {
      return acc + item?.quantity;
    }, 0);
    return totalQuantity;
  };

  const loadMoreItems = async () => {
    setLoadingMore(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setVisibleItems(visibleItems + 10);
    } finally {
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    dispatch(getOrderHistoryAction(uid));
  }, [dispatch, uid]);

  const toTitleCase = (str) =>
  str.replace(/\b\w/g, (char) => char.toUpperCase());


  return (
    <>
      <Container className="order_history pb-3">
        <MainNavigation title={"Orders History"} />
        <>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            aria-label="order status tabs"
            TabIndicatorProps={{
              style: {
                backgroundColor: color,
              },
            }}
            className="mb-3"
          >
            <Tab
              label="Active"
              value="active"
              sx={{
                color: darkMode ? "#fff" : "inherit",
                fontWeight: 500,
                "&.Mui-selected": {
                  color: color,
                },
              }}
            />
            <Tab
              label="Completed"
              value="completed"
              sx={{
                color: darkMode ? "#fff" : "inherit",
                fontWeight: 500,
                "&.Mui-selected": {
                  color: color,
                },
              }}
            />{" "}
            <Tab
              label="Closed"
              value="closed"
              sx={{
                color: darkMode ? "#fff" : "inherit",
                fontWeight: 500,
                "&.Mui-selected": {
                  color: color,
                },
              }}
            />
            <Tab
              label="Refunded"
              value="refunded"
              sx={{
                color: darkMode ? "#fff" : "inherit",
                fontWeight: 500,
                "&.Mui-selected": {
                  color: color,
                },
              }}
            />
          </Tabs>

          {getOrders ? (
            <Container className="py-5 d-flex justify-content-center align-items-center">
              <RestaurantLoader message="Fetching Order History" />
            </Container>
          ) : (
            <>
              {filterOrders(activeTab)?.length > 0 ? (
                <>
                  <Row className="d-flex justify-content-start align-items-start">
                    {" "}
                    {filterOrders(activeTab)
                      ?.slice(0, visibleItems)
                      ?.map((item, index) => (
                        <Col xl={6} md={12} className="mb-3" key={item.id}>
                          <Card
                            className={`p-3 cursor-pointer ${
                              darkMode
                                ? "order_history__card-dark"
                                : "order_history__card"
                            }`}
                          >
                            <Row className="d-flex justify-content-between align-items-center">
                              <Col
                                className={`d-flex justify-content-between ${
                                  darkMode
                                    ? "order_history__content-dark"
                                    : "order_history__content"
                                }`}
                              >
                                <div className="d-flex flex-column justify-content-center align-items-start">
                                  <p className="mb-2 fs--10 typograpghy">
                                    ID: {item?.id}
                                  </p>
                                  <h3
                                    className="mb-2 fs--18 fw--600 title text-truncate"
                                    title={item?.order
                                      ?.map((obj) => obj?.name)
                                      .join(", ")}
                                    style={{ maxWidth: "280px" }}
                                  >
                                    {item?.order?.map((obj, id) => (
                                      <React.Fragment key={id}>
                                        {toTitleCase(obj?.name)}
                                      </React.Fragment>
                                    ))}
                                  </h3>

                                  <p className="mb-2 fs--12 typograpghy">
                                    {(() => {
                                      const totalQty = totalquantity(
                                        item?.order
                                      );
                                      return totalQty > 1
                                        ? `${totalQty} items`
                                        : `${totalQty} item`;
                                    })()}{" "}
                                    |{" "}
                                    {moment
                                      .unix(item?.createdAt?.seconds)
                                      .format("DD MMMM YYYY")}
                                  </p>
                                  <p
                                    className="mb-0 fs--14 price fw--600"
                                    style={{
                                      color,
                                    }}
                                  >
                                    $
                                    {item?.finalPrice
                                      ? item?.finalPrice
                                      : item?.totalAmount}
                                  </p>
                                </div>

                                <div className="d-flex flex-column justify-content-between align-items-end">
                                  <div className="d-flex justify-content-center align-items-center cursor-pointer">
                                    <p className="mb-0 mx-2 fs--16 order_status text-capitalize">
                                      {item.status}
                                    </p>
                                    <img
                                      src={
                                        item.status === "completed"
                                          ? completed
                                          : item.status === "refunded"
                                          ? cancel
                                          : incomplete
                                      }
                                      alt="status"
                                    />
                                  </div>

                                  {item?.tipPayment?.tipAdded && (
                                    <div className="mb-2 mr-3 d-flex align-items-center fs--12 typograpghy">
                                      <span className="text-success fw--600">
                                        Tip Added
                                      </span>
                                      {item?.tipPayment?.totalAmount && (
                                        <>
                                          <span className="mx-1 text-muted">
                                            •
                                          </span>
                                          <span
                                            style={{ color }}
                                            className="fw--600"
                                          >
                                            {item?.currency || "$"}
                                            {item.tipPayment.totalAmount}
                                          </span>
                                        </>
                                      )}
                                    </div>
                                  )}

                                  <div className="d-flex">
                                    <Button
                                      className="order_btn"
                                      style={{
                                        background: color,
                                      }}
                                      onClick={() =>
                                        history.push(
                                          `/tracking/orderID=${item.id}?tracking=true`
                                        )
                                      }
                                    >
                                      Track Order
                                    </Button>
                                    {item.status === "completed" &&
                                      !item?.tipPayment?.tipAdded && (
                                        <Button
                                          className="order_btn ml-1"
                                          style={{
                                            background: color,
                                          }}
                                          onClick={() => handleModal(item)}
                                        >
                                          Add Tip
                                        </Button>
                                      )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      ))}
                  </Row>
                </>
              ) : (
                <Row className="mt-2 justify-content-center position-relative">
                  <h3
                    className={`mb-0 py-5  ${
                      darkMode ? "text-white" : "text-black"
                    }`}
                  >
                    No Order Added yet
                  </h3>
                </Row>
              )}
            </>
          )}
          <div className="d-flex justify-content-center align-items-center py-4">
            {filterOrders(activeTab)?.length > visibleItems && (
              <Button
                className="order_btn fw--500 px-4 py-2"
                onClick={loadMoreItems}
                disabled={loadingMore}
                style={{
                  backgroundColor: color,
                  borderRadius: "30px",
                  boxShadow: `0 4px 12px ${color}50`,
                  border: "none",
                  fontSize: "16px",
                  transition: "all 0.3s ease-in-out",
                }}
                onMouseEnter={(e) => {
                  e.target.style.boxShadow = `0 6px 18px ${color}70`;
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.boxShadow = `0 4px 12px ${color}50`;
                  e.target.style.transform = "scale(1)";
                }}
              >
                Load More
              </Button>
            )}
          </div>
        </>
      </Container>

      <TipModal
        restaurantID={restaurantId}
        OrderId={OrderId}
        price={price}
        modal={modal}
        currency={currency}
        setModal={setModal}
        darkMode={darkMode}
        color={color}
        setTipAdded={setTipAdded}
      />
    </>
  );
};

export default OrderHistory;
